import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import { connect } from 'react-redux';
import RegionsActions, { RegionsSelectors } from '@redux/RegionsRedux';
import { MultiSelect } from '@components/form';
import { Button, Row } from 'antd';
import API from '@utils/api';
import { object, array } from 'yup';

function AssignHkForm(props) {
  const {
    setVisible,
    property: { propertyID },
    property: { housekeepers },
    updatePropertyHks,
    regionData,
    regionData: { housekeepers: regionHks }
  } = props;

  const validationSchema = object().shape({
    housekeepers: array()
      .required('Housekeeper is required')
      .min(1, 'Please select at least 1 housekeeper')
      .max(4, 'Up to 4 housekeepers can be selected')
  });

  //this handles error if there are no hks on property
  let initialHks = { housekeepers: [] };
  if (housekeepers && housekeepers[0].firstName) {
    initialHks = {
      housekeepers: housekeepers.map(hk => hk.housekeeperID.toString())
    };
  }

  const formatOptions = hks =>
    hks.map(hk => ({
      label: hk.firstName + ' ' + hk.lastName,
      value: hk.housekeeperID.toString()
    }));
  const options = formatOptions(regionHks);

  const hkRegionValidation = newHkIDs => {
    for (let i = 0; i < newHkIDs.length; i++) {
      let lookUp = regionHks.filter(hk => hk.userID == newHkIDs[i])[0];
      if (!lookUp) {
        throw Error('At least one housekeeper is not assigned to the region');
      }
    }
  };

  const handleSubmit = async (values, actions) => {
    const { setSubmitting, setStatus } = actions;
    setSubmitting(true);
    try {
      const valuesToSend = {
        regionID: props.property.regionID,
        housekeepers: values.housekeepers.map(hkId => parseInt(hkId))
      };
      if (!valuesToSend) {
        throw Error('No Housekeepers Selected');
      }
      hkRegionValidation(valuesToSend.housekeepers);
      await API.updateHkPreferences(propertyID, valuesToSend);
      updatePropertyHks(regionData, valuesToSend.housekeepers, propertyID);
      setVisible(false);
    } catch (err) {
      if (err.message) {
        setStatus(err.message);
      }
    }
    setSubmitting(false);
  };
  return (
    <Formik
      initialValues={initialHks}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      isInitialValid={validationSchema.isValidSync(initialHks)}
      render={({ isValid, isSubmitting, status }) => {
        return (
          <Form className="create-form ant-form-vertical">
            <Row gutter={16}>
              <Field
                component={MultiSelect}
                name="housekeepers"
                showSearch
                options={options}
                mode="multiple"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                label="Housekeepers"
              />
            </Row>
            <Row style={{ marginBottom: '8px' }}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={!isValid || isSubmitting}
              >
                Submit
              </Button>
            </Row>
            {status && <Row>{status}</Row>}
          </Form>
        );
      }}
    />
  );
}

AssignHkForm.propTypes = {
  property: PropTypes.object,
  setVisible: PropTypes.func,
  regionData: PropTypes.object,
  updatePropertyHks: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  updatePropertyHks: (regionData, newHkIDs, propertyID) => {
    dispatch(
      RegionsActions.setRegionDataPropertyHks(regionData, newHkIDs, propertyID)
    );
  }
});

const mapStateToProps = state => ({
  regionData: RegionsSelectors.selectRegionData(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignHkForm);
